import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

export const store = new Vuex.Store({
         state: {
           view: "",
           bearhouse: ["853384435005817"],
           gbpayment: ["998122266996445"],
           page2c2p: [
             "110710877332627",
             "160733491520",
             "107235216024674",
             "103551424764072",
             "112085313900804",
             "102421048239798",
             "105928254552462",
             "114621593252079",
             "115414076948160", //test 2c2p
             "392612533487",
             "104716585038207",
             "362065616073",
           ],
           cds: [
             "110710877332627",
             "160733491520",
             "107235216024674",
             "394274810994296",
             "103551424764072",
             "392612533487",
             "11462159325207",
             "114621593252079",
             "112085313900804",
             "102421048239798",
             "105928254552462",
             "134297248716",
             "408054729252920",
             "122424499005",
           ],
           // cds: [],
           //  '394274810994296', //moo
           khaiwhan: ["103617407715034"],
           ros: ["113937150302402"],
           loadingCart: undefined,
           cart: [],
           isWholesale: false,
           wholesale: [],
           theme: {
             color: "#cecece",
           },
           pageProfile: undefined,
           loadingPageProfile: true,
           allowProductRemark: ["102434044554028"],
           influencerid: localStorage.getItem("influencerid")
             ? localStorage.getItem("influencerid")
             : null,
         },
         mutations,
         actions,
         getters,
       });
